import { Box, Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { getFeatureToggle } from 'utils/feature-toggle';
import { features } from 'utils/feature-toggle/constants';
import { Feature } from 'utils/feature-toggle/types';
import { setInLocalStorage } from 'utils/storage';

type FormData = Record<Feature, boolean>;

const FeaturesToggler = () => {
  const { handleSubmit, register } = useForm<FormData>({});

  const handleSaveFeatures = (data: FormData) => {
    Object.entries(data).forEach(([key, value]) => {
      setInLocalStorage(key, value);
    });
    window.location.reload();
  };

  return (
    <div className='navpanel__item-link'>
      <Box component='form' onSubmit={handleSubmit(handleSaveFeatures)}>
        <Typography variant='article' sx={{ my: 2 }}>
          Features
        </Typography>
        <Stack spacing={4}>
          <Box display='flex' flexDirection='column'>
            {features.map((feat) => (
              <FormControlLabel
                key={feat}
                control={
                  <Checkbox
                    defaultChecked={getFeatureToggle({ name: feat })}
                    {...register(`${feat}`)}
                  />
                }
                label={feat}
              />
            ))}
          </Box>
          <Button variant='cta' fullWidth type='submit'>
            Save
          </Button>
        </Stack>
      </Box>
    </div>
  );
};

export { FeaturesToggler };
